import { baseThunk } from '../../fetch/basicThunk';
import {
    QUERY_GET_CUSTOMERS,
    QUEY_GET_MASTER_COUNT,
    QUERY_GET_ALL_CUSTOMERS_ALL,
    QUERY_GET_CUSTOMERS_PAG,
    QUERY_POST_CREATE_CUSTOMER,
    QUERY_PUT_EDIT_CUSTOMER,
    QUERY_DELETE_CUSTOMER,
    QUERY_PUT_TOGGLE_ACTIVE_CUSTOMER
} from '../../fetch/constantQueries';

export const postCustomerList = baseThunk("customerList/postCustomerList", QUERY_GET_CUSTOMERS, "GET");
export const postCustomerCount = baseThunk("customerList/postCustomerCount", QUEY_GET_MASTER_COUNT, "GET");
export const getAllCustomers = baseThunk("customers/getAllCustomers", QUERY_GET_ALL_CUSTOMERS_ALL, "GET");

export const getCustomersPag = baseThunk("customers/getCustomersPag", QUERY_GET_CUSTOMERS_PAG, "GET");
export const createCustomer = baseThunk("customers/create", QUERY_POST_CREATE_CUSTOMER, "POST");
export const editCustomer = baseThunk("customers/update", QUERY_PUT_EDIT_CUSTOMER, "PUT");
export const deleteCustomer = baseThunk("customers/delete", QUERY_DELETE_CUSTOMER, "DELETE");
export const toggleActiveCustomer = baseThunk("customers/toggleActive", QUERY_PUT_TOGGLE_ACTIVE_CUSTOMER, "PUT");